import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Link } from "react-router-dom";
import './StickyFooter.scss'
import path from "../../routes/path";
import { userData } from "../../config/sessionKeys";

const StickyFooter = () => {
    const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);
    let isLoggedIn = JSON.parse(localStorage.getItem(userData));
    return (
        <>
            <div className="sticky-footer-menu">
                <ul>
                    <li><NavLink to={`${process.env.PUBLIC_URL}${path.home}`}>
                        <i className="fa-solid fa-house" />
                        <span>{t('header.home')}</span>
                    </NavLink></li>
                    <li><NavLink to={`${process.env.PUBLIC_URL}${path.courses_new + "?page=1"}`}>
                        <i className="fa-solid fa-book" />
                        <span>{t('header.courses')}</span>
                    </NavLink></li>
                    <li><NavLink to={`${process.env.PUBLIC_URL}${path.contact}`}>
                        <i className="fa-regular fa-comment" />
                        <span>{t('header.contact')}</span>
                    </NavLink></li>
                    <li><a
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="menu-icon" href="javascript:void(0)">
                        <i className="fa-solid fa-bars" />
                        <span>{t('header.menu')}</span>
                    </a></li>
                </ul>
            </div>
            {/*Mobile Modal Menu*/}
            <div className={menuOpen ? "mobile-modal-menu active" : "mobile-modal-menu"}>
                <strong><span onClick={() => setMenuOpen(false)} className="back-btn"><i className="bi bi-chevron-left" /></span>  {t('header.menu')}</strong>
                <ul>
                    {!isLoggedIn ?
                        <>
                            <li className={"w-50"}><Link className="login_sign_up" to={`${process.env.PUBLIC_URL}${path.login}`} onClick={() => setMenuOpen(false)}>{t('header.login')}</Link></li>
                            <li className={"w-50 br-0"}><Link className="login_sign_up" to={`${process.env.PUBLIC_URL}${path.registration}`} onClick={() => setMenuOpen(false)}>{t('header.signup')}</Link></li>
                        </>
                        : null}
                    <li><Link to={`${process.env.PUBLIC_URL}${path.about}`} onClick={() => setMenuOpen(false)}>{t('header.about_us')}</Link></li>
                    <li><Link to={`${process.env.PUBLIC_URL}${path.courses_new + "?page=1"}`} onClick={() => setMenuOpen(false)}>{t('header.courses')}</Link></li>
                    <li><Link to={`${process.env.PUBLIC_URL}${path.instructors}`} onClick={() => setMenuOpen(false)}>{t('header.instructor')}</Link></li>
                    <li><Link to={`${process.env.PUBLIC_URL}${path.publishing_books + "?page=1"}`}  onClick={() => setMenuOpen(false)}>{t('header.books')}</Link></li>
                    {/* <li><Link to={`${process.env.PUBLIC_URL}${path.donation}`} onClick={() => setMenuOpen(false)}>{t('header.donation')}</Link></li> */}
                    <li><Link to={`${process.env.PUBLIC_URL}${path.blog + "?page=1"}`} onClick={() => setMenuOpen(false)}>{t('header.blog')} </Link></li>
                    <li><Link to={`${process.env.PUBLIC_URL}${path.gallery}`} onClick={() => setMenuOpen(false)}>{t('header.gallery')}</Link></li>
                    <li><Link to={`${process.env.PUBLIC_URL}${path.contact}`} onClick={() => setMenuOpen(false)}>{t('header.contact_us')}</Link></li>
                    {/* <li>
                        <div className="accordion accordion-flush" id="accordionFlushExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                        <span className="content">Content</span>
                                    </button>
                                </h2>
                                <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                    <ul>
                                        <li><Link to={`${process.env.PUBLIC_URL}${path.events + "?page=1"}`} onClick={() => setMenuOpen(false)}>{t('header.events')} </Link></li>
                                        <li><Link to={`${process.env.PUBLIC_URL}${path.news + "?page=1"}`} onClick={() => setMenuOpen(false)}>{t('header.news')} </Link></li>
                                        <li><Link to={`${process.env.PUBLIC_URL}${path.article + "?page=1"}`} onClick={() => setMenuOpen(false)}>{t('header.article')} </Link></li>
                                        <li><Link to={`${process.env.PUBLIC_URL}${path.blog + "?page=1"}`} onClick={() => setMenuOpen(false)}>{t('header.blog')} </Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li> */}
                    <li><Link to={`${process.env.PUBLIC_URL}${path.faq}`} onClick={() => setMenuOpen(false)}>{t('footer.faq')}</Link></li>
                    {/* <li><Link to={`${process.env.PUBLIC_URL}${path.contact}`} onClick={() => setMenuOpen(false)}>{t('footer.help_supprt')}</Link></li> */}
                    <li><Link to={`${process.env.PUBLIC_URL}${path.career}`} onClick={() => setMenuOpen(false)}>{t('footer.career')}</Link></li>
                    <li><Link to={`${process.env.PUBLIC_URL}${path.terms_of_service}`} onClick={() => setMenuOpen(false)}>{t('footer.terms_of_service')}</Link></li>
                    <li><Link to={`${process.env.PUBLIC_URL}${path.privacy_policy}`} onClick={() => setMenuOpen(false)}>{t('footer.privacy_policy')}</Link></li>
                    <li><Link to={`${process.env.PUBLIC_URL}${path.refund_policy}`} onClick={() => setMenuOpen(false)}>{t('footer.refund_policy')}</Link></li>
                    <li><Link to={`${process.env.PUBLIC_URL}${path.our_strength}`} onClick={() => setMenuOpen(false)}>{t('footer.our_strength')}</Link></li>
                </ul>
            </div>
        </>
    )
}
export default StickyFooter;